
import { Component, Emit, Prop, Vue } from 'vue-property-decorator'
import SettingsFormItem from './views/FormItem/index.vue'
import Input from './views/Input/index.vue'
import Select from './views/Select/index.vue'
import DatePicker from './views/DatePicker/index.vue'
import Divider from './views/Divider/index.vue'
import Cascader from './views/Cascader/index.vue'
import HeaderImage from '@xt/www/components/headerImage/index.vue'
import UpdateAvatar from './views/UpdateAvatar/index.vue'
import { Observer } from 'mobx-vue'
import { dataSource_My } from '@xt/client'
import type { UserInfo } from '@xt/client/entities/user/types'
import { getLocationCascader } from '@xt/client/dataSource/china/index'
import lodash from 'lodash'
import LazyImg from '@xt/www/components/lazyImg/index.vue'
import Qrcode from '@xt/www/components/showQrcode/index.vue'
import { EnumOpenMiniProgramPage } from '@xt/client/enums/mini/index'
import { Bind, Debounce } from 'lodash-decorators'

@Observer
@Component({
  components: {
    SettingsFormItem,
    Input,
    Select,
    DatePicker,
    Divider,
    Cascader,
    HeaderImage,
    UpdateAvatar,
    LazyImg,
    Qrcode
  }
})
export default class MySettingsMyself extends Vue {
  @Prop({ required: true }) userInfo: UserInfo

  userInfoValue: (UserInfo & { locationCascader: [] }) | null = null

  get EnumOpenMiniProgramPage() {
    return EnumOpenMiniProgramPage
  }

  get dataSource_My() {
    return dataSource_My
  }

  get UserStore() {
    return this.$store.$storeUser
  }

  @Debounce(300, { leading: true, trailing: false })
  @Bind()
  async onUpdate() {
    try {
      if (!this.userInfoValue) return

      let data = lodash.cloneDeep(this.userInfoValue)
      // 去掉昵称
      lodash.unset(data, 'nickname')
      // 转换地址
      data = getLocationCascader(data, true)

      // await this.UserStore.onUpdateUserInfo(data)

      this.$msg(this.$EnumMessage.save_success, 'success')

      const res = await this.UserStore.onUpdatingUserInfo()

      if (!res) return

      this.onUpdateUserInfoValue(res)
    } catch (error) {
      this.$msg(error)
    }
  }

  async onUpdateUserInfoValue(userInfo: UserInfo) {
    let data = lodash.pick(userInfo, [
      'nickname', // 昵称
      'address', // 地址
      'birthday', // 生日
      'career', // 职业
      'education', // 学历
      'id', //id
      'industry', // 行业
      'location', // 所在地（0 未知，1 国内，2国外）
      'city', // 城市
      'country', // 国家
      'province', // 省份
      'sex' // 性别(0 未知 1 男 2女)
    ])
    this.userInfoValue = {
      ...getLocationCascader(data)
    }
  }

  async created() {
    // 获取所在地
    await this.$store.$location.onGetLocationResource()
    // 获取收货地址
    await this.$store.$storeUser.onRefreshUserAddress()

    this.onUpdateUserInfoValue(this.toJS(this.userInfo))
  }

  mounted() {}

  updated() {}

  destroyed() {}
}
